import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import Link from 'next/link';
import React from 'react';
import { useTranslation } from 'react-i18next';

var Footer = function Footer(_ref) {
  var footerNavigation = _ref.footerNavigation;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs("footer", {
    className: "text-white gradient",
    "aria-labelledby": "footer-heading",
    children: [/*#__PURE__*/_jsx("h2", {
      id: "footer-heading",
      className: "sr-only",
      children: t('landing.footer')
    }), /*#__PURE__*/_jsxs("div", {
      className: "px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:py-16 lg:px-8",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "xl:grid xl:grid-cols-3 xl:gap-8",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "grid grid-cols-2 gap-8 xl:col-span-2",
          children: [/*#__PURE__*/_jsx("div", {
            className: "md:grid md:grid-cols-2 md:gap-8",
            children: /*#__PURE__*/_jsxs("div", {
              className: "mt-12 md:mt-0",
              children: [/*#__PURE__*/_jsx("h3", {
                className: "text-sm font-semibold tracking-wider text-gray-400 uppercase",
                children: t('landing.footerNavigation.supportTitle')
              }), /*#__PURE__*/_jsx("ul", {
                className: "mt-4 space-y-4",
                children: footerNavigation.support.map(function (item) {
                  return /*#__PURE__*/_jsx("li", {
                    children: /*#__PURE__*/_jsx(Link, {
                      href: item.href,
                      children: /*#__PURE__*/_jsx("a", {
                        target: "_blank",
                        className: "text-base text-gray-500 hover:text-gray-200",
                        children: t(item.name)
                      })
                    })
                  }, item.name);
                })
              })]
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "md:grid md:grid-cols-2 md:gap-8",
            children: /*#__PURE__*/_jsxs("div", {
              className: "mt-12 md:mt-0",
              children: [/*#__PURE__*/_jsx("h3", {
                className: "text-sm font-semibold tracking-wider text-gray-400 uppercase",
                children: t('landing.footerNavigation.legalTitle')
              }), /*#__PURE__*/_jsx("ul", {
                className: "mt-4 space-y-4",
                children: footerNavigation.legal.map(function (item) {
                  return /*#__PURE__*/_jsx("li", {
                    children: /*#__PURE__*/_jsx("a", {
                      href: item.href,
                      target: "_blank",
                      rel: "noreferrer",
                      className: "text-base text-gray-500 hover:text-gray-200",
                      children: t(item.name) || ''
                    })
                  }, item.name);
                })
              })]
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "mt-8 xl:mt-0",
          children: [/*#__PURE__*/_jsx("h3", {
            className: "text-sm font-semibold tracking-wider text-gray-400 uppercase",
            children: t('landing.subscribeToNewsletter')
          }), /*#__PURE__*/_jsx("p", {
            className: "mt-4 text-base text-gray-500",
            children: t('landing.subscribeToNewsletterDesc')
          }), /*#__PURE__*/_jsxs("form", {
            className: "mt-4 sm:flex sm:max-w-md",
            method: "POST",
            action: "https://forms.hubspot.com/uploads/form/v2/25296347/bc20ff33-6779-4e4a-8f2f-b3e66c6aeaeb",
            children: [/*#__PURE__*/_jsx("label", {
              htmlFor: "email-address",
              className: "sr-only",
              children: t('landing.subscribeToNewsletterEmailAddress')
            }), /*#__PURE__*/_jsx("input", {
              type: "email",
              name: "email",
              id: "email-address",
              autoComplete: "email",
              required: true,
              className: "w-full min-w-0 px-4 py-2 text-base text-gray-900 placeholder-gray-500 bg-white border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:placeholder-gray-400",
              placeholder: t('landing.subscribeToNewsletterEmailAddressPlaceHolder')
            }), /*#__PURE__*/_jsx("div", {
              className: "mt-3 rounded-md sm:mt-0 sm:ml-3 sm:flex-shrink-0",
              children: /*#__PURE__*/_jsx("button", {
                type: "submit",
                className: "flex items-center justify-center w-full px-4 py-2 text-base font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700 focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                children: t('landing.subscribeToNewsletterButton')
              })
            })]
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "pt-8 mt-8 border-t border-gray-200 md:flex md:items-center md:justify-between",
        children: [/*#__PURE__*/_jsx("div", {
          className: "flex space-x-6 md:order-2",
          children: footerNavigation.social.map(function (item) {
            return /*#__PURE__*/_jsx(Link, {
              href: item.href,
              children: /*#__PURE__*/_jsxs("a", {
                target: "_blank",
                className: "text-gray-400 hover:text-gray-500",
                children: [/*#__PURE__*/_jsx("span", {
                  className: "sr-only",
                  children: t(item.name)
                }), /*#__PURE__*/_jsx(item.icon, {
                  className: "w-6 h-6",
                  "aria-hidden": "true"
                })]
              })
            }, item.name);
          })
        }), /*#__PURE__*/_jsxs("p", {
          className: "mt-8 text-base text-gray-400 md:mt-0 md:order-1",
          children: ["\xA9", ' ', "".concat(new Date().getUTCFullYear(), " ").concat(t('landing.powerdByYalendar'))]
        })]
      })]
    })]
  });
};

export default Footer;